import { render } from "./SiKaoView.vue?vue&type=template&id=51d65de6&scoped=true&ts=true"
import script from "./SiKaoView.vue?vue&type=script&lang=ts"
export * from "./SiKaoView.vue?vue&type=script&lang=ts"

import "./SiKaoView.vue?vue&type=style&index=0&id=51d65de6&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d65de6"]])

export default __exports__